import { useMemo } from 'react';
import { useCurrentNumber } from './useCurrentNumber';

export function useCurrentMSISDN() {
  const context = useCurrentNumber();
  const msisdn = useMemo(() => context?.msisdn || '', [context?.msisdn]);
  return msisdn;
}
